import { Pipe, PipeTransform } from '@angular/core';
import { BID_CUT_REQUEST_CONFIG } from '../../hammer/hammer-bid-cut-request.config';

@Pipe({
  name: 'pendingRequestsMessage'
})
export class PendingRequestsMessagePipe implements PipeTransform {
  transform(count: number): string {
    const validCount = Math.max(0, Math.floor(count || 0));
    
    if (validCount <= 0) {
      return '';
    }
    
    if (validCount > BID_CUT_REQUEST_CONFIG.MAX_PENDING_DISPLAY) {
      return `${BID_CUT_REQUEST_CONFIG.MAX_PENDING_DISPLAY}+ usuarios están solicitando partir la puja del lote`;
    }
    
    return `${validCount} usuario${validCount > 1 ? 's' : ''} adicional${validCount > 1 ? 'es' : ''} ${validCount > 1 ? 'están' : 'está'} solicitando partir la puja del lote`;
  }
}

